import { hexToRgb } from '../helpers';
import { NameBadge, NameBadgeProps } from './NameBadge';

interface ColorBadgeProps extends Omit<NameBadgeProps, 'color'> {
  color: string | null;
  opacity?: number;
}

export function ColorBadge({
  color,
  opacity = 0.25,
  ...props
}: ColorBadgeProps) {
  const variant = color ? 'custom' : 'default';
  const rgbColor = color ? hexToRgb(color) : undefined;

  const style = rgbColor && color ? {
    background: `rgba(${rgbColor}, ${opacity})`,
  } : undefined;

  return (
    <NameBadge
      variant={variant}
      style={style}
      {...props}
    />
  );
}
